import React, { useState } from "react";
import ContactFormModal from "../../../GlobalComponents/ContactFormModal"; // adjust path if needed

const ServicesHero = () => {
  const [showContactForm, setShowContactForm] = useState(false);

  const handleFreeInspection = () => {
    setShowContactForm(true);
  };

  const handleEmergencyCall = () => {
    window.location.href = "tel:+27119340990";
  };

  return (
    <section className="hero-container">
      <div className="hero-background-overlay"></div>
      <div className="hero-content">
        <div className="hero-text-container">
          <h1 className="hero-title">
            Professional Pest Control
            <span className="hero-highlight"> Services</span>
          </h1>
          <p className="hero-subtitle">
            Comprehensive pest management solutions for homes, businesses, and agricultural properties. 
            Our certified technicians use eco-friendly methods and cutting-edge technology to protect 
            your space from unwanted pests.
          </p>
          <div className="hero-stats">
            <div className="hero-stat">
              <div className="hero-stat-number">98%</div>
              <div className="hero-stat-label">Success Rate</div>
            </div>
            <div className="hero-stat">
              <div className="hero-stat-number">24/7</div>
              <div className="hero-stat-label">Emergency Service</div>
            </div>
            <div className="hero-stat">
              <div className="hero-stat-number">ECO</div>
              <div className="hero-stat-label">Friendly</div>
            </div>
          </div>
          <div className="hero-cta-buttons">
            <button className="hero-primary-button" onClick={handleFreeInspection}>
              Get Free Inspection
            </button>
            <button className="hero-secondary-button" onClick={handleEmergencyCall}>
              Emergency Call
            </button>
          </div>
        </div>
        <div className="hero-image-container">
          <img 
            src="https://images.unsplash.com/photo-1581578731548-c64695cc6952?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80"
            alt="Professional Pest Control"
            className="hero-image"
          />
        </div>
      </div>

      {/* Contact Form Modal */}
      <ContactFormModal
        isOpen={showContactForm}
        onClose={() => setShowContactForm(false)}
      />

      <style jsx>{`
        .hero-container {
          position: relative;
          padding: 3rem 2rem;
          background: linear-gradient(135deg, #1a2980 0%, #26d0ce 100%);
          color: white;
          overflow: hidden;
          font-family: system-ui, -apple-system, "Segoe UI", Roboto, sans-serif;
        }
        
        .hero-background-overlay {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0,0,0,0.3);
          z-index: 1;
        }
        
        .hero-content {
          position: relative;
          z-index: 2;
          max-width: 1200px;
          margin: 0 auto;
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 2rem;
          align-items: center;
        }
        
        .hero-text-container {
          padding-right: 2rem;
        }
        
        .hero-title {
          font-size: 3rem;
          font-weight: bold;
          margin: 0 0 1.2rem 0;
          line-height: 1.2;
        }
        
        .hero-highlight {
          background: linear-gradient(45deg, #26d0ce, #1a2980);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }
        
        .hero-subtitle {
          font-size: 1.1rem;
          line-height: 1.5;
          margin: 0 0 1.5rem 0;
          opacity: 0.9;
        }
        
        .hero-stats {
          display: flex;
          gap: 2rem;
          margin: 1.5rem 0;
        }
        
        .hero-stat {
          text-align: center;
        }
        
        .hero-stat-number {
          font-size: 2rem;
          font-weight: bold;
          margin-bottom: 0.5rem;
        }
        
        .hero-stat-label {
          font-size: 0.9rem;
          opacity: 0.8;
        }
        
        .hero-cta-buttons {
          display: flex;
          gap: 1rem;
          margin-top: 1.5rem;
        }
        
        .hero-primary-button {
          background: linear-gradient(45deg, #26d0ce, #1a2980);
          color: white;
          border: none;
          padding: 12px 30px;
          border-radius: 8px;
          font-weight: bold;
          cursor: pointer;
          font-size: 1rem;
          transition: all 0.3s ease;
        }
        
        .hero-primary-button:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 20px rgba(38, 208, 206, 0.4);
        }
        
        .hero-secondary-button {
          background: transparent;
          color: white;
          border: 2px solid white;
          padding: 12px 30px;
          border-radius: 8px;
          font-weight: bold;
          cursor: pointer;
          font-size: 1rem;
          transition: all 0.3s ease;
        }
        
        .hero-secondary-button:hover {
          background: rgba(255, 255, 255, 0.1);
          transform: translateY(-2px);
        }
        
        .hero-image-container {
          position: relative;
        }
        
        .hero-image {
          width: 100%;
          height: 350px;
          object-fit: cover;
          border-radius: 12px;
          box-shadow: 0 20px 40px rgba(0,0,0,0.3);
        }

        @media (max-width: 968px) {
          .hero-container {
            padding: 2.5rem 1.5rem;
          }
          
          .hero-content {
            grid-template-columns: 1fr;
            gap: 1.5rem;
          }
          
          .hero-text-container {
            padding-right: 0;
            text-align: center;
          }
          
          .hero-title {
            font-size: 2.2rem;
          }
          
          .hero-subtitle {
            font-size: 1rem;
          }
          
          .hero-stats {
            justify-content: center;
          }
          
          .hero-cta-buttons {
            justify-content: center;
          }
          
          .hero-image {
            height: 300px;
          }
        }

        @media (max-width: 768px) {
          .hero-container {
            padding: 2rem 1rem;
          }
          
          .hero-title {
            font-size: 1.8rem;
            margin-bottom: 0.8rem;
          }
          
          .hero-subtitle {
            font-size: 0.95rem;
            margin-bottom: 1rem;
          }
          
          .hero-stats {
            gap: 1.5rem;
            margin: 1.2rem 0;
          }
          
          .hero-stat-number {
            font-size: 1.6rem;
          }
          
          .hero-stat-label {
            font-size: 0.85rem;
          }
          
          .hero-cta-buttons {
            flex-direction: column;
            gap: 0.75rem;
            margin-top: 1.2rem;
          }
          
          .hero-primary-button,
          .hero-secondary-button {
            width: 100%;
            padding: 12px 20px;
          }
          
          .hero-image {
            height: 250px;
          }
        }

        @media (max-width: 480px) {
          .hero-container {
            padding: 1.5rem 1rem;
          }
          
          .hero-title {
            font-size: 1.5rem;
          }
          
          .hero-subtitle {
            font-size: 0.9rem;
          }
          
          .hero-stats {
            gap: 1rem;
            flex-wrap: wrap;
          }
          
          .hero-stat {
            flex: 1;
            min-width: 80px;
          }
          
          .hero-stat-number {
            font-size: 1.4rem;
          }
          
          .hero-image {
            height: 200px;
          }
        }
      `}</style>
    </section>
  );
};

export default ServicesHero;